import externalPrecompro from '@/store/types/externalPrecompro';

const state = {};

const actions = {
  [externalPrecompro.actions.addDataPeopleMotul]: (state, data) => {
    return new Promise((resolve, reject) => {
      this.$http.post('motul/addMotulPeopleData', data.send)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
const getters = {};

const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations
};
